import {addCommasToNumber} from "../../utils";

export const offeringSummary = {
    name: 'OFFERING SUMMARY',
    rows: []
};

export const leaseSummary = {
    name: 'LEASE SUMMARY',
    rows: []
};

export const annualizedOperatingData = {
    name: 'ANNUALIZED OPERATING DATA',
    header: ['Year(s)', 'Commencement', 'Annual', 'Increase'],
    rows: []
};

export const rentPricingData ={
    name: 'RENT PRICING DATA',
    header: ['Rent PSF', 'Monthly Rent', 'Annual Rent','Aggressive', 'Anticipated','Conservative'],
    percentageHeaders:[],
    rows: []
}

export const netOperatingIncome = {
    name: 'NET OPERATING INCOME',
    value: ''
};

export const getOfferingSummaryData = function (tables) {
    const isCheckClearHeights = tables['offering-summary'].rows['clear-height'].value;
    const isCheckDoors = tables['offering-summary'].rows['doors'].value;
    const isCheckOfficeToWarehouse = tables['offering-summary'].rows['office-to-warehouse'].value;

    const offeringSummaryData = [{
        label: 'Price',
        value: tables['offering-summary'].rows['price'].getComputedValue(tables).displayValue
    }, {
        label: 'Cap Rate',
        value: tables['offering-summary'].rows['cap-rate'].value ?
            `${tables['offering-summary'].rows['cap-rate'].value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`
            :
            '-'
    }, {
        label: 'Price PSF',
        value: tables['offering-summary'].rows['price-psf'].value ?
            `$${addCommasToNumber(tables['offering-summary'].rows['price-psf'].value)} PSF`
            :
            '-'
    }, {
        label: 'Net Operating Income',
        value: tables['offering-summary'].rows['net-operating-income'].getComputedValue(tables).displayValue
    }, {
        label: 'Year Built',
        value: tables['offering-summary'].rows['year-built'].value
    }, {
        label: 'Gross Leasable Area',
        value: `${addCommasToNumber(tables['offering-summary'].rows['gross-leasable-area'].value)} SF`
    }, {
        label: 'Lot Size',
        value: `${tables['offering-summary'].rows['lot-size'].value} Acres`
    }];

    if (isCheckClearHeights) {
        offeringSummaryData.push({
            label: 'Clear Height',
            value:`${tables['offering-summary'].rows['clear-height'].value} Ft`
        })
    }
    if (isCheckDoors) {
        offeringSummaryData.push({
            label: 'Doors',
            value: tables['offering-summary'].rows['doors'].value
        })
    }
    if (isCheckOfficeToWarehouse) {
        offeringSummaryData.push({
            label: 'Office to Warehouse',
            value: tables['offering-summary'].rows['office-to-warehouse'].value
        })
    }
    return offeringSummaryData;
};

export const getLeaseSummaryData = function (tables) {
    const isCheckGuarantor = tables['lease-summary'].rows['guarantor'].value;
    const isCheckOptionPurchase = tables['lease-summary'].rows['options-to-purchase'].value;

    const leaseSummaryData = [{
        label: 'Lease Term',
        value: tables['lease-summary'].rows['original-lease-term'].value ? `${tables['lease-summary'].rows['original-lease-term'].value} ${tables['lease-summary'].rows['original-lease-term'].value <= 1 ? 'Year' : 'Years'}` : tables['lease-summary'].rows['original-lease-term'].getComputedValue(tables).displayValue
    }, {
        label: 'Lease Commencement',
        value: tables['lease-summary'].rows['lease-commencement'].value ? tables['lease-summary'].rows['lease-commencement'].value : tables['general-information'].rows['sale-lease-back'].value === 'Yes'?tables['lease-summary'].rows['lease-commencement'].getComputedValue(tables).displayValue : '-'
    }, {
        label: 'Lease Expiration',
        value: tables['lease-summary'].rows['lease-expiration'].value ? tables['lease-summary'].rows['lease-expiration'].value : tables['general-information'].rows['sale-lease-back'].value === 'Yes'?tables['lease-summary'].rows['lease-expiration'].getComputedValue(tables).displayValue : '-'
    }, {
        label: 'Remaining Term',
        value: tables['lease-summary'].rows['remaining-term'].getComputedValue(tables).displayValue
    }, {
        label: 'Lease Type',
        value: tables['lease-summary'].rows['lease-type'].value
    }, {
        label: 'Roof & Structure',
        value: tables['lease-summary'].rows['roof-and-structure'].getComputedValue(tables).displayValue
    }, {
        label: 'Increases',
        value: tables['lease-summary'].rows['increases'].value
    }, {
        label: 'Options',
        value: tables['lease-summary'].rows['options'].value
    }];

    if (isCheckOptionPurchase) {
        leaseSummaryData.push({
            label: 'Options to Purchase',
            value: tables['lease-summary'].rows['options-to-purchase'].value ? tables['lease-summary'].rows['options-to-purchase'].dropdownValues.filter(res => res.code === tables['lease-summary'].rows['options-to-purchase'].value)[0].name : "-"
        })
    } 
    if (isCheckGuarantor) {
        leaseSummaryData.push({
            label: 'Guarantor',
            value: tables['lease-summary'].rows['guarantor'].value || '-'
        })
    }
    return leaseSummaryData;
};

export const getAnnualizedOperatingData = function (tables) {
    // 0 - Years     1 - Commencement     2 - Annual     3 - Increase
    const rows = tables['annualized-operating-data'].rows;
    const annualRentIndex = 2;
    const commencementIndex = 1;    
    return Object.keys(rows)
        .filter(key => rows[key].valueCells[0].value)
        .map(key => {
            return {
                valueCells: new Array(4).fill(null).map((cell, cellIndex) => {
                    const isSaleLeaseBack = tables['general-information']['rows']['sale-lease-back'].value;
                   
                    if(cellIndex==commencementIndex){
                       
                            rows[key].valueCells[cellIndex].hidden=true;
                       
                        if(isSaleLeaseBack=='No' || !isSaleLeaseBack){
                            rows[key].valueCells[cellIndex].hidden=false;
                        }
                    }
                    if (rows[key].valueCells[cellIndex].editable)
                        return {
                            value: rows[key].valueCells[cellIndex].value
                        };
                    if (cellIndex === annualRentIndex)
                        return {
                            value: rows[key].valueCells[cellIndex].getComputedValue(tables, key).internalValue ?
                                rows[key].valueCells[cellIndex].getComputedValue(tables, key).displayValue.toLocaleString()
                                :
                                '-'
                        }
                 try{
                        return {
                            value: rows[key].valueCells[cellIndex].getComputedValue(tables, key).displayValue
                        }
                    }
                    catch(ex){
                    }
                    
                })
            }
    });
};

export const getNetOperatingIncomeData = function (tables) {
    return tables['offering-summary'].rows['net-operating-income'].getComputedValue(tables).internalValue ?
        tables['offering-summary'].rows['net-operating-income'].getComputedValue(tables).displayValue.toLocaleString()
        :
        '-';
};

export const getRentPricingData = function (tables) {
    const rows = tables['pricing-rent-matrix'].rows;
    const newRows = Object.keys(rows).reduce((result, key) => {
        // excluding the edited rows and their data in the print view
        if (!['base-rent-psf','price-percentages','rent-adjustment','sqft'].includes(key)) {
            result[key] = rows[key];
        }
        return result;
    }, {});

    const categories = Object.keys(newRows);

    const createValueCells = (index) => {
        return categories.map(category => ({
            value: newRows[category].valueCells[index].getComputedValue(tables).displayValue
        }));
    };
    const rentPricingtTable = Array.from({ length: 7 }, (_, index) => ({
        valueCells: createValueCells(index)
    }));

    return rentPricingtTable
}

export const getRentPricePercentageHeaders = function (tables) {
    const rows = tables['pricing-rent-matrix'].rows;
    let percentageHeaders = []
    if (Object.keys(rows).length && rows['price-percentages'] &&
        Object.keys(rows['price-percentages']).length &&
        rows['price-percentages'].valueCells &&
        rows['price-percentages'].valueCells.length) {
        rows['price-percentages'].valueCells.map((item, index) => {
            if (index >= 3) {
                percentageHeaders.push(item.value||'')
            }
        })

        return percentageHeaders;
    }
}